module.exports = __webpack_public_path__ + "static/media/shopify.cfa33fbc.svg";